import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);   // undefined = loading, null = guest
  const [ready, setReady] = useState(false);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("sankalak_token");
    if (!token) { setUser(null); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/azure/me");   // Azure validator (id-scheme)
      setUser(data);
    } catch {
      localStorage.removeItem("sankalak_token");
      setUser(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes("token=")) {
      const token = hash.split("token=")[1]?.split("&")[0];
      if (token) {
        localStorage.setItem("sankalak_token", token);
        window.history.replaceState({}, document.title, "/dashboard");
      }
    }
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sankalak_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("sankalak_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}